import { render, staticRenderFns } from "./FrzChamberViewGraphicsDetail.vue?vue&type=template&id=d8f8fed2"
import script from "./FrzChamberViewGraphicsDetail.vue?vue&type=script&lang=js"
export * from "./FrzChamberViewGraphicsDetail.vue?vue&type=script&lang=js"
import style0 from "./FrzChamberViewGraphicsDetail.vue?vue&type=style&index=0&id=d8f8fed2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports